import moment from "moment";
import { displayDateFormat } from "config/dateInput";

export default function getTodayUTC() {
  return moment
    .utc(moment().format(displayDateFormat), displayDateFormat)
    .valueOf();
}
